(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4820],{

/***/ 6582:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_error",
      function () {
        return __webpack_require__(7627);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _error; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
;// CONCATENATED MODULE: ./src/components/atoms/messages/ErrorStatus.js


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 21px;\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
/**
 * Error Status Message
 * @param {object} props
 * @param {number} statusCode 에러 상태 코드
 */ var ErrorStatusMessage = function(param) {
    var statusCode = param.statusCode;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message, {
            children: [
                statusCode,
                " | Error Page"
            ]
        })
    }));
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e086fc-0"
})(_templateObject());
var Message = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-14e086fc-1"
})(_templateObject1());
/* harmony default export */ var ErrorStatus = (ErrorStatusMessage);

;// CONCATENATED MODULE: ./pages/_error.js

// components

var ErrorPage = function(param) {
    var statusCode = param.statusCode;
    // useEffect(() => {
    //   request
    //     .put('/next/api/v1/logging', {
    //       type: 'ERROR',
    //       statusCode,
    //       message: errorMessage ? errorMessage : '에러 메세지가 없습니다.',
    //     })
    //     .catch(() => {});
    // }, [statusCode, errorMessage]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorStatus, {
            statusCode: statusCode
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var _error = (ErrorPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6582); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);